module.exports = __webpack_public_path__ + "img/icon-基金-n@2x_11247.png";